var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIconV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.416 12.75C11.416 10.417 9.01601 8.083 6.083 8.083C3.15 8.083 0.75 10.417 0.75 12.75M6.083 6.75C6.87865 6.75 7.64171 6.43393 8.20431 5.87132C8.76691 5.30871 9.08301 4.54565 9.08301 3.75C9.08301 2.95435 8.76691 2.19129 8.20431 1.62868C7.64171 1.06607 6.87865 0.75 6.083 0.75C5.28735 0.75 4.52429 1.06607 3.96168 1.62868C3.39907 2.19129 3.083 2.95435 3.083 3.75C3.083 4.54565 3.39907 5.30871 3.96168 5.87132C4.52429 6.43393 5.28735 6.75 6.083 6.75Z",
    stroke: "#949699",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconV2);
export default __webpack_public_path__ + "static/media/user-icon-v2.58f711423eacd730bed96036aa7f350c.svg";
export { ForwardRef as ReactComponent };